import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CBOPaymentsListComponent } from './cbo-payments-list/cbo-payments-list.component';
import { CBOPaymentsDetailsComponent } from './cbo-payments-details/cbo-payments-details.component';
import { CBOPaymentsItemListService } from 'src/app/core/service/grid-data/grid-data-cbo-payments-item.service';
import { ExcelModule } from '@progress/kendo-angular-grid';

@NgModule({
  declarations: [
    CBOPaymentsListComponent,
    CBOPaymentsDetailsComponent
  ],
  imports: [
    SharedModule,
    ExcelModule
  ],
  exports: [
    CBOPaymentsListComponent,
    CBOPaymentsDetailsComponent
  ],
  providers: [
    CBOPaymentsItemListService
  ]
})
export class CBOPaymentsModule { }
